import { render, staticRenderFns } from "./event_invite.vue?vue&type=template&id=0da2bf10&"
import script from "./event_invite.vue?vue&type=script&lang=js&"
export * from "./event_invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports